<template>
  <nav class="navbar-container">
    <span>
      Hello, {{ userName }}
    </span>
    <img
      @click="logout()"
      :src="require('../../assets/icons/logout.svg')"
      alt="logout"
    />
    <template v-if="config">
      <ModalConfig
        @closeConfig="config=$event"
      />
    </template>
  </nav>
</template>
<script>
import ModalConfig from '@/components/Modal/ModalConfig.vue';
import { isSignedIn, signOut } from '../../auth/auth';

export default {
  name: 'Header',
  data() {
    return {
      modal: false,
      userName: '',
      config: false,
    };
  },
  components: {
    ModalConfig,
  },
  mounted() {
    if (!isSignedIn()) {
      this.$router.push('/');
    }
    this.userName = localStorage.getItem('user');
  },
  methods: {
    logout() {
      signOut();
      return this.$router.push('/');
    },
    openConfig() {
      this.config = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.navbar-container {
  padding-right: 49px;
  height: 83px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-shadow: 0px 0px 7px rgba(48, 48, 48, 0.25);
  @media (max-width: 600px) {
    padding-right: 20px;
    img {
      margin-left: 15px;
    }
  }
  span {
    font-weight: 600;
    font-size: 20px;
    color: $header;
  }
  img {
    cursor: pointer;
    margin-left: 20px;
  }
  .config {
    margin-right: 0px;
    width:25px;
  }
}
</style>
